export var createCollapsibleDriver = function (wrapper, idx) {
    if (idx === void 0) { idx = 0; }
    var base = wrapper.$$('.collapsible').get(idx);
    return {
        getTitle: function () { return base.$('.title').text(); },
        isOpen: function () { return base.hasClass('open'); },
        toggle: function () { return base.$('.title-wrapper').click(); },
        toggleIconClick: function () { return base.$('.toggle-icon-wrapper').click(); },
        isDisabled: function () { return base.hasClass('disabled'); },
    };
};
//# sourceMappingURL=driver.js.map